import React from 'react';
import ErrorModal from '../../../common/ErrorModal';
import ImageToVideoUpload from './ImageToVideoUpload';
import ImageToVideoControls from './ImageToVideoControls';
import { useImageToVideo } from './useImageToVideo';

const ImageToVideoTab = ({ onResult, onGeneratingChange }) => {
  const {
    file, setFile,
    keyframe, setKeyframe,
    startFrame, setStartFrame,
    endFrame, setEndFrame,
    prompt, setPrompt,
    model, setModel,
    videoMode, setVideoMode,
    aspectRatio, setAspectRatio,
    videoResolution, setVideoResolution,
    videoDuration, setVideoDuration,
    modelOptions,
    videoModeOptions,
    aspectRatioOptions,
    videoResolutionOptions,
    videoDurationOptions,
    previewUrl, openPreview, closePreview,
    isGenerating,
    generationProgress,
    errorModal, setErrorModal,
    inputRef,
    inputStartRef,
    inputEndRef,
    credits,
    canGenerate,
    onPick,
    onPickStart,
    onPickEnd,
    handleGenerate
  } = useImageToVideo({ onResult, onGeneratingChange });

  return (
    <div className="veo2-form">
      <ImageToVideoUpload
        file={file}
        setFile={setFile}
        keyframe={keyframe}
        setKeyframe={setKeyframe}
        startFrame={startFrame}
        setStartFrame={setStartFrame}
        endFrame={endFrame}
        setEndFrame={setEndFrame}
        inputRef={inputRef}
        inputStartRef={inputStartRef}
        inputEndRef={inputEndRef}
        onPick={onPick}
        onPickStart={onPickStart}
        onPickEnd={onPickEnd}
        openPreview={openPreview}
      />

      <div className="veo2-form__body">
        <ImageToVideoControls
          prompt={prompt}
          setPrompt={setPrompt}
          model={model}
          setModel={setModel}
          mode={videoMode}
          setMode={setVideoMode}
          ratio={aspectRatio}
          setRatio={setAspectRatio}
          resolution={videoResolution}
          setResolution={setVideoResolution}
          duration={videoDuration}
          setDuration={setVideoDuration}
          modelOptions={modelOptions}
          modeOptions={videoModeOptions}
          ratioOptions={aspectRatioOptions}
          resolutionOptions={videoResolutionOptions}
          durationOptions={videoDurationOptions}
          credits={credits}
          isGenerating={isGenerating}
          generationProgress={generationProgress}
          canGenerate={canGenerate}
          handleGenerate={handleGenerate}
        />
      </div>

      {previewUrl && (
        <div className="veo2-modal" onClick={closePreview}>
          <div className="veo2-modal__content" onClick={(e) => e.stopPropagation()}>
            <img className="veo2-modal__img" src={previewUrl} alt="preview" />
            <button className="veo2-modal__close" onClick={closePreview}>×</button>
          </div>
        </div>
      )}
      <ErrorModal
        open={errorModal.open}
        title={errorModal.title}
        message={errorModal.message}
        onClose={() => setErrorModal({ open: false, title: '', message: '' })}
      />
    </div>
  );
};

export default ImageToVideoTab;
